module.exports = __webpack_public_path__ + "miscusi_logo_mobile_red-9wp.svg";